angular.module('agreements')
    .service('AgreementOfferService', function (modals, $rootScope, Agreement, AgreementConst) {
        this.add = params => {
            let entity = {
                id: null,
                attachments: []
            }
            angular.extend(entity, params)
            return this.edit(entity)
        }
        this.edit = entity => {
            modals.open('app/agreements/offer/edit-modal.html', 'AgreementOfferEditController', angular.copy(entity), {size: 'lg'}, "$ctrl")
        }
        this.diff = entities => {
            modals.open('app/agreements/offer/diff-modal.html', 'AgreementOfferDiffController', angular.copy(entities), {size: 'lg'}, "$ctrl")
        }
    })
    .run(function (NavbarLeftMenu) {
        NavbarLeftMenu.add({
            authorities: 'ROLE_CONTRACT_OFFERS',
            path: '/agreement-offer',
            ico: 'fa fa-fw fa-file-text-o',
            name: 'agreement-offer.menu',
            order: 81,
        })
    })
    .config(function ($stateProvider) {
        $stateProvider
            .state('agreementOfferList', {
                parent: 'app',
                url: '/agreement-offer?{page:int}&{size:int}&{sort:string}&{search:string}&signingDateStart&signingDateEnd&periodStart&periodEnd&category&project&costCenter&costType&filesCountFilter&filter&type&status&clients',
                data: {
                    authorities: ['ROLE_CONTRACT_OFFERS'],
                },
                params: {
                    filter: {value: 'all', squash: true},
                    status: {array: true, value: [], squash: false},
                    clients: {array: true},
                },
                views: {
                    'content@': 'agreementOfferList'
                },
                resolve: {
                    filters: $stateParams => angular.copy($stateParams),
                    page: (Agreement, $stateParams) => Agreement.tableOffer(angular.copy($stateParams)).$promise,
                    statistics: (Agreement, $stateParams) => Agreement.tableOfferStatistics(angular.copy($stateParams)).$promise
                }
            })

    })
